module.exports = __webpack_public_path__ + "static/media/iaijutsu.cd838a92.png";


//////////////////
// WEBPACK FOOTER
// ./src/skillicons/iaijutsu.png
// module id = 57
// module chunks = 0